import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const slug = 'mini-excavation-sydney';
const serviceId = 1
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {
    const metaTags : MetaTagsProps =  {
        title: `Mini Excavation Sydney | ${BUSINESS_NAME}`,
        description: "Perfect for backyards, landscaping, and small-scale projects. Our mini excavators are ideal for tight or difficult access areas.",
        keywords: "mini excavation sydney, small-scale excavation, backyard excavation, landscaping excavation, tight access excavation, mini digger hire, trenching services, site preparation, residential excavation, commercial excavation, custom excavation solutions, construction project management, sydney builders",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Mini Excavation',
    description: 'Perfect for backyards, landscaping, and small-scale projects. Our mini excavators are ideal for tight or difficult access areas.',
    points: [],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
